<template>
    <div id="Visit_Details">
        <FormSection
            :full-height="true"
            title="Find a Match"
            :show-background="false"
            :show-product-pill="true"
            :application-id="2"
        >
            <template #content>
                <section v-if="isLoading" slot="content" class="p-5 d-flex flex-column text-center text-primary">
                    <i class="fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite"></i>
                    <span class="mt-1">
                        <b>Loading...</b>
                    </span>
                </section>
                <section slot="content" id="Find_A_Match" class="task-details d-flex flex-column p-md-3" v-else>
                    <div class="container m-0 p-md-1">
                        <div>
                            <p class="fw-bold">Task Information</p>
                            <div class="w-100" v-if="matchDetails">
                                <div class="input-group flex-md-nowrap w-100">
                                    <div class="form-group w-25">
                                        <label for="taks-name" class="fw-bold">Client <span class="pe-2"></span></label>
                                        <span>{{
                                            matchDetails.clientName ? matchDetails.clientName : "Unassigned"
                                        }}</span>
                                    </div>
                                    <div class="form-group w-50">
                                        <label for="taks-name" class="fw-bold"
                                            >Is all day <span class="pe-2"></span
                                        ></label>
                                        <span>{{ matchDetails.isAllDay ? "Yes" : "No" }}</span>
                                    </div>
                                </div>
                                <div class="input-group flex-md-nowrap w-100">
                                    <div class="form-group w-25">
                                        <label for="taks-name" class="fw-bold">Payer <span class="pe-2"></span></label>
                                        <span>Caregiver 123</span>
                                    </div>
                                    <div class="form-group w-50">
                                        <label for="taks-name" class="fw-bold">From <span class="pe-2"></span></label>
                                        <span>{{ payload.startDate }}</span>
                                    </div>
                                </div>
                                <div class="input-group flex-md-nowrap w-100">
                                    <div class="form-group w-25">
                                        <label for="taks-name" class="fw-bold">Task <span class="pe-2"></span></label>
                                        <span>{{ matchDetails.task }}</span>
                                    </div>
                                    <div class="form-group w-50">
                                        <label for="taks-name" class="fw-bold">To <span class="pe-2"></span></label>
                                        <span>{{ payload.endDate }}</span>
                                    </div>
                                </div>
                                <div class="input-group flex-md-nowrap">
                                    <div class="form-group w-100">
                                        <label for="taks-name" class="fw-bold">Tags <span class="pe-2"></span></label>
                                        <span
                                            v-for="tag of matchDetails.patientTags"
                                            :value="tag"
                                            class="tag ms-2 p-1 rounded fw-bold"
                                            >{{ tag }}</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <p class="fw-bold">Matching Options</p>
                            <p class="mt-2 fw-normal border-bottom">Caregiver Criteria</p>
                            <div class="table-responsive w-50">
                                <table class="table border border-gray">
                                    <thead>
                                        <tr class="bg-table-header">
                                            <th>
                                                <div class="input-label">
                                                    <input
                                                        type="checkbox"
                                                        class="me-1"
                                                        v-model="requiredAllSelected"
                                                        @change="requiredAllSelectedChanged()"
                                                    /><span>Required</span>
                                                </div>
                                            </th>
                                            <th>
                                                <div class="input-label">
                                                    <input
                                                        type="checkbox"
                                                        class="me-1"
                                                        v-model="preferredAllSelected"
                                                        @change="preferredAllSelectedChanged()"
                                                    /><span>Preferred</span>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="data of caregiver">
                                            <td>
                                                <div class="input-label">
                                                    <input
                                                        type="checkbox"
                                                        class="me-1"
                                                        :value="data.key"
                                                        :checked="checkRequiredMatches(data.key)"
                                                        @change="requiredSelectionChanged(data.key)"
                                                    />
                                                    <span>{{ data.name }}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="input-label">
                                                    <input
                                                        type="checkbox"
                                                        class="me-1"
                                                        :value="data.key"
                                                        :checked="checkpreferredMatches(data.key)"
                                                        @change="preferredSelectionChanged(data.key)"
                                                    />
                                                    <span>{{ data.name }}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div>
                            <div class="d-flex border-bottom">
                                <p class="fw-bold">Client Criteria</p>
                                <a
                                    class="ms-2 cursor-pointer text-decoration-none"
                                    data-bs-toggle="collapse"
                                    href="#collapseExample"
                                    aria-expanded="false"
                                    aria-controls="collapseExample"
                                    role="button"
                                    @click="show = !show"
                                    >{{ show ? "Hide" : "View" }}</a
                                >
                            </div>
                            <div class="collapse" id="collapseExample">
                                <div class="table-responsive w-100 mt-2">
                                    <table class="table border border-gray">
                                        <tr class="bg-table-header">
                                            <th></th>
                                            <th>License Certifications</th>
                                            <th>Skills</th>
                                            <th>Transfers</th>
                                            <th>Personality Traits</th>
                                            <th>Pets</th>
                                            <th>General</th>
                                        </tr>
                                        <tr>
                                            <td class="fw-bold">Required</td>
                                            <td v-if="requiredCriteria['License/Certifications'].length === 0">--</td>
                                            <td v-else>
                                                <p v-for="data of requiredCriteria['License/Certifications']">
                                                    {{ data.description }}
                                                </p>
                                            </td>
                                            <td v-if="requiredCriteria.Skills.length === 0">--</td>
                                            <td v-else>
                                                <p v-for="data of requiredCriteria.Skills">{{ data.description }}</p>
                                            </td>
                                            <td v-if="requiredCriteria.Transfers.length === 0">--</td>
                                            <td v-else>
                                                <p v-for="data of requiredCriteria.Transfers">{{ data.description }}</p>
                                            </td>
                                            <td v-if="requiredCriteria['Personality Traits'].length === 0">--</td>
                                            <td v-else>
                                                <p v-for="data of requiredCriteria['Personality Traits']">
                                                    {{ data.description }}
                                                </p>
                                            </td>
                                            <td v-if="requiredCriteria.Pets.length === 0">--</td>
                                            <td v-else>
                                                <p v-for="data of requiredCriteria.Pets">{{ data.description }}</p>
                                            </td>
                                            <td v-if="requiredCriteria.General.length === 0">--</td>
                                            <td v-else>
                                                <p v-for="data of requiredCriteria.General">{{ data.description }}</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="fw-bold">Desired</td>
                                            <td v-if="desiredCriteria['License/Certifications'].length === 0">--</td>
                                            <td v-else>
                                                <p v-for="data of desiredCriteria['License/Certifications']">
                                                    {{ data.description }}
                                                </p>
                                            </td>
                                            <td v-if="desiredCriteria.Skills.length === 0">--</td>
                                            <td v-else>
                                                <p v-for="data of desiredCriteria.Skills">{{ data.description }}</p>
                                            </td>
                                            <td v-if="desiredCriteria.Transfers.length === 0">--</td>
                                            <td v-else>
                                                <p v-for="data of desiredCriteria.Transfers">{{ data.description }}</p>
                                            </td>
                                            <td v-if="desiredCriteria['Personality Traits'].length === 0">--</td>
                                            <td v-else>
                                                <p v-for="data of desiredCriteria['Personality Traits']">
                                                    {{ data.description }}
                                                </p>
                                            </td>
                                            <td v-if="desiredCriteria.Pets.length === 0">--</td>
                                            <td v-else>
                                                <p v-for="data of desiredCriteria.Pets">{{ data.description }}</p>
                                            </td>
                                            <td v-if="desiredCriteria.General.length === 0">--</td>
                                            <td v-else>
                                                <p v-for="data of desiredCriteria.General">{{ data.description }}</p>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex w-100 mt-3 justify-content-between">
                            <div class="d-flex flex-column w-45">
                                <p class="fw-bold border-bottom">Availability</p>
                                <label class="input-label">
                                    <input
                                        type="radio"
                                        class="me-1"
                                        :value="1"
                                        :checked="availability == 1"
                                        v-model="availability"
                                    />Full Availability
                                </label>
                                <label class="input-label">
                                    <input
                                        type="radio"
                                        class="me-1"
                                        :value="2"
                                        :checked="availability == 2"
                                        v-model="availability"
                                    />Any Availability
                                </label>
                            </div>

                            <div class="d-flex flex-column w-45">
                                <p class="fw-bold border-bottom">Oriented</p>
                                <label class="input-label">
                                    <input type="radio" class="me-1" :value="true" v-model="isOriented" />Yes
                                </label>
                                <label class="input-label">
                                    <input type="radio" class="me-1" :value="false" v-model="isOriented" />No
                                </label>
                            </div>
                        </div>
                        <div id="Tags_Container" class="container m-0 p-1 d-flex flex-column col-12">
                            <p class="fw-bold w-100 border-bottom">Tags</p>
                            <div class="tag-option">
                                <label class="mb-2 w-5 input-label">
                                    <input
                                        type="radio"
                                        class="me-1"
                                        :value="0"
                                        :checked="tagsOptions === 0"
                                        v-model="tagsOptions"
                                        @change="tagOptionsChanged(0)"
                                    />None
                                </label>
                            </div>
                            <div class="d-flex align-items-center w-100 tag-option">
                                <div class="me-1 w-5">
                                    <label class="input-label">
                                        <input
                                            type="radio"
                                            class="me-1"
                                            :value="1"
                                            :checked="tagsOptions === 1"
                                            v-model="tagsOptions"
                                            @change="tagOptionsChanged(1)"
                                        />
                                        Any
                                    </label>
                                </div>
                                <div v-if="matchDetails" class="input-group d-flex w-20 flex-nowrap me-1">
                                    <div class="flex-shrink-1 flex-grow-1">
                                        <MultiSelectDropdown
                                            name="any"
                                            :disabled="tagsOptions !== 1"
                                            :options="matchDetails.employeeTags"
                                            :selected-items="anyUserTags"
                                            v-on:selectedItemsUpdated="anyUserTagsUpdated"
                                            :has-actions="true"
                                        />
                                    </div>
                                </div>
                                <div class="w-50">
                                    <span
                                        >When Any is selected, employees can have any of the tags selected to
                                        display</span
                                    >
                                </div>
                            </div>
                            <div class="d-flex align-items-center w-100 mt-2 tag-option">
                                <div class="me-1 w-5">
                                    <label class="input-label">
                                        <input
                                            type="radio"
                                            class="me-1"
                                            :value="2"
                                            :checked="tagsOptions === 2"
                                            v-model="tagsOptions"
                                            @change="tagOptionsChanged(2)"
                                        />
                                        All
                                    </label>
                                </div>
                                <div v-if="matchDetails" class="input-group d-flex w-20 flex-nowrap me-1">
                                    <div class="flex-shrink-1 flex-grow-1">
                                        <MultiSelectDropdown
                                            name="all"
                                            :disabled="tagsOptions !== 2"
                                            :options="matchDetails.employeeTags"
                                            :selected-items="allUserTags"
                                            v-on:selectedItemsUpdated="allUserTagsUpdated"
                                            :has-actions="true"
                                        />
                                    </div>
                                </div>
                                <div class="w-50">
                                    <span
                                        >When All is selected, employees must have all of the tags selected to
                                        display</span
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
                            <button class="btn btn-primary me-2" @click="findAMatch()">Find</button>
                            <button class="btn btn-primary" @click="closeFindMatch()">Cancel</button>
                        </div>
                        <div class="d-flex flex-column">
                            <div class="d-flex align-items-center justify-content-between">
                                <p class="fw-bold table-title">Matching Results</p>
                                <button class="btn btn-primary mb-1" @click="sendMatchMessage()">Send Message</button>
                            </div>
                            <div class="table-responsive w-100 mt-2">
                                <table class="table border border-gray">
                                    <thead>
                                        <tr class="bg-table-header">
                                            <th></th>
                                            <th>Caregiver</th>
                                            <th>Distance</th>
                                            <th>Relationship</th>
                                            <th>Phone Number</th>
                                            <th>Required Criteria</th>
                                            <th>Preferred Criteria</th>
                                            <th>Tags</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- EMPTY -->
                                        <tr class="table-empty" v-if="!findingMatches && matchingResults.length === 0">
                                            <td :colspan="columns">
                                                <h3>No Matches Found</h3>
                                            </td>
                                        </tr>
                                        <tr v-if="findingMatches" v-for="i of columns" class="table-loading">
                                            <td v-for="i of columns">
                                                <span class="shimmer-loading"></span>
                                            </td>
                                        </tr>
                                        <tr
                                            v-if="!findingMatches && matchingResults.length > 0"
                                            v-for="data of matchingResults"
                                        >
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    model="data.userId"
                                                    :value="data.userId"
                                                    :checked="checkUserIds(data.userId)"
                                                    @change="userIdsChanged(data.userId)"
                                                />
                                            </td>
                                            <td>{{ data.displayName }}</td>
                                            <td>{{ data.distance }}</td>
                                            <td>{{ data.relationship }}</td>
                                            <td>{{ data.phoneNumber }}</td>
                                            <td v-if="data.requiredMatches.length === 0">No Criteria Matched</td>
                                            <td v-else>{{ data.requiredMatches.length }}</td>
                                            <td v-if="data.preferredMatches.length === 0">No Criteria Matched</td>
                                            <td v-else>{{ data.preferredMatches.length }}</td>
                                            <td v-if="data.tags.length === 0">No Tags</td>
                                            <td v-else>{{ data.tags.length }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-center">
                            <button class="btn btn-primary me-2" @click="handleCaregiverSelection()">
                                Use Selected Match
                            </button>
                            <button class="btn btn-primary" @click="closeFindMatch()">Cancel</button>
                        </div>
                    </div>
                </section>
            </template>
            <template #content_2>
                <div class="d-flex mt-2 me-2 justify-content-end">
                    <img src="../../../../img/Axxess_Intelligence_logo_2.svg" alt="" class="mb-2" />
                    <button class="ai-premium-btn ms-2 mt-1 mb-2">Premium</button>
                </div>
                <div class="ai-line"></div>
            </template>
        </FormSection>
    </div>
</template>

<style src="./FindAMatch.scss"></style>
<script lang="ts" src="./FindAMatch"></script>
